const opportunityOption = require('./opportunity-option');

export default {
  OpportunityOption: opportunityOption,
};
